import { useState } from 'react';
import {
  LineChart, Line, BarChart, Bar,
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import { FaChartLine, FaChartBar } from 'react-icons/fa';

const KpiChart = ({ label = '', value = [] }) => {
  const [mode, setMode] = useState('line');

  const maxVal = Math.max(0, ...value.map(d => d.value ?? 0));
  const minVal = Math.min(maxVal, ...value.map(d => d.value ?? 0));
  const yMax = Math.ceil(maxVal * 1.1);
  const yMin = Math.max(0, Math.floor(minVal * 0.9));
  const showDots = value.length <= 50;

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <div style={{
        position: 'absolute', top: 4, right: 12, zIndex: 10,
        display: 'flex', gap: 4, background: '#1a1a1a', borderRadius: 6, padding: '3px 4px',
      }}>
        <button
          onClick={() => setMode('line')}
          style={{
            background: mode === 'line' ? '#3b82f6' : 'transparent',
            border: 'none', borderRadius: 4, padding: '4px 8px',
            color: '#e2e4e8', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4,
            fontSize: 12,
          }}
        >
          <FaChartLine size={12} />
        </button>
        <button
          onClick={() => setMode('bar')}
          style={{
            background: mode === 'bar' ? '#3b82f6' : 'transparent',
            border: 'none', borderRadius: 4, padding: '4px 8px',
            color: '#e2e4e8', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4,
            fontSize: 12,
          }}
        >
          <FaChartBar size={12} />
        </button>
      </div>

      <ResponsiveContainer width="100%" height="100%">
        {mode === 'line' ? (
          <LineChart data={value}>
            <CartesianGrid strokeDasharray="3 3" stroke="#333" />
            <XAxis dataKey="name" tick={{ fill: '#a0a4a8', fontSize: 11 }} />
            <YAxis domain={[yMin, yMax]} tick={{ fill: '#a0a4a8', fontSize: 11 }} />
            <Tooltip
              contentStyle={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: 6 }}
              labelStyle={{ color: '#e2e4e8' }}
              itemStyle={{ color: '#8884d8' }}
            />
            <Line
              type="monotone"
              dataKey="value"
              name={label}
              stroke="#8884d8"
              strokeWidth={2}
              dot={showDots ? { r: 3, fill: '#8884d8' } : false}
              activeDot={{ r: 5 }}
              isAnimationActive
            />
          </LineChart>
        ) : (
          <BarChart data={value}>
            <CartesianGrid strokeDasharray="3 3" stroke="#333" />
            <XAxis dataKey="name" tick={{ fill: '#a0a4a8', fontSize: 11 }} />
            <YAxis domain={[0, yMax]} tick={{ fill: '#a0a4a8', fontSize: 11 }} />
            <Tooltip
              contentStyle={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: 6 }}
              labelStyle={{ color: '#e2e4e8' }}
              itemStyle={{ color: '#8884d8' }}
            />
            <Bar
              dataKey="value"
              name={label}
              fill="#8884d8"
              radius={[4, 4, 0, 0]}
              isAnimationActive
            />
          </BarChart>
        )}
      </ResponsiveContainer>
    </div>
  );
};

export default KpiChart;
